<template>
  <div class="grid grid-cols-12">
    <!-- left side -->
    <div class="col-span-12 lg:col-span-4 bg-maroon" style="">
      <div class="text-center">
        <img class="mx-auto" src="../assets/cp-logo.png" alt="" width="135" height="87">
        <div class="judson judson-400 text-xl text-[#84CCF2] md:text-[26px] mt-8">Registration Form for CP Meet</div>
        <div class="judson judson-700 text-[40px] leading-[52px] mt-12 text-[#E6E6E6] md:text-[50px]">Jet Trinity<br>Towers</div>
        <div class="judson  judson-400 text-[#E6E6E6] mt-2.5 text-[23px] md:text[33px]">Santacruz</div>
        <svg class="mx-auto mt-7 max-w-full" xmlns="http://www.w3.org/2000/svg" width="370" height="1" viewBox="0 0 370 1" fill="none">
        <rect opacity="0.7" width="370" height="1" rx="0.5" fill="url(#paint0_linear_2001_61)"/>
        <defs>
        <linearGradient id="paint0_linear_2001_61" x1="0" y1="0.5" x2="370" y2="0.5" gradientUnits="userSpaceOnUse">
        <stop stop-color="#312642"/>
        <stop offset="0.5" stop-color="#AAC2E7"/>
        <stop offset="1" stop-color="#312642"/>
        </linearGradient>
        </defs>
        </svg>

        <div class="flex flex-row lg:flex-col gap-10 my-10">
          <div class="grow">
            <img class="mx-auto" src="../assets/calendar-icon.svg" width="24" height="24" alt="">
            <div class="judson judson-700 text-[#E6E6E6] text-base leading-[18px] mt-4 md:text-[22px] md:leading-6">13th November</div>
          </div>
          <div class="grow">
            <img class="mx-auto" src="../assets/time-icon.svg" width="24" height="24" alt="">
            <div class="judson judson-700 text-[#E6E6E6] text-base leading-[18px] mt-4 md:text-[22px] md:leading-6">11 AM Onwards</div>
          </div>
          <div class="grow">
            <img class="mx-auto" src="../assets/location-icon.svg" width="24" height="24" alt="">
            <div class="judson judson-700 text-[#E6E6E6] text-base leading-[18px] mt-4 md:text-[22px] md:leading-6">Santacruz</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right side -->
    <div class="col-span-12 lg:col-span-8 md:px-12 py-20 min-h-[100vh] bg-pattern">
      <div class="inter inter-600 text-[#163052] text-center lg:text-left text-lg leading-5 mb-10 md:text-[27px] md:leading-8">Register Now for the CP Meet</div>
      <form class="bg-white md:rounded-md border border-[#E6E6E6] p-7 shadow-md" @submit.prevent="submitFn()">
        <div class="grid grid-cols-1 md:grid-cols-2">
          <div class="col-span-1 md:pr-3">
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="name">Full Name *</label>
              <input required class="rounded border border-[#CCCCCC] inter inter-400 text-[15px] block w-full p-4 leading-[16px] ring-[#6176AB] focus:border-[#6176AB] focus:ring-[#6176AB] focus-visible::border-[#6176AB] focus-visible::ring-[#6176AB] transition-all"
                type="text" name="name" v-model.trim="cpParams.name" id="name"  placeholder="Full Name">
            </div>
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="email">Email</label>
              <input class="rounded border border-[#CCCCCC] inter inter-400 text-[15px] block w-full p-4 leading-[16px] ring-[#6176AB] focus:border-[#6176AB] focus:ring-[#6176AB] focus-visible::border-[#6176AB] focus-visible::ring-[#6176AB] transition-all"
                type="email" name="email" v-model.trim="cpParams.email" id="email" placeholder="Email">
            </div>
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="cpFirmName">Channel Partner Firm Name *</label>
              <input required class="rounded border border-[#CCCCCC] inter inter-400 text-[15px] block w-full p-4 leading-[16px] ring-[#6176AB] focus:border-[#6176AB] focus:ring-[#6176AB] focus-visible::border-[#6176AB] focus-visible::ring-[#6176AB] transition-all"
                type="text" name="cpFirmName" v-model.trim="cpParams.firm_name" id="cpFirmName" placeholder="Channel Partner Firm Name">
            </div>
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="cpFirmName">Rera No</label>
              <input class="rounded border border-[#CCCCCC] inter inter-400 text-[15px] block w-full p-4 leading-[16px] ring-[#6176AB] focus:border-[#6176AB] focus:ring-[#6176AB] focus-visible::border-[#6176AB] focus-visible::ring-[#6176AB] transition-all"
                type="text" name="cpFirmName" v-model.trim="cpParams.rera_no" id="cpFirmName" placeholder="Rera No">
            </div>
          </div>
          <div class="col-span-1 md:pl-3">
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="mobile">Mobile Number *</label>
              <input required class="rounded border border-[#CCCCCC] inter inter-400 text-[15px] block w-full p-4 leading-[16px] ring-[#6176AB] focus:border-[#6176AB] focus:ring-[#6176AB] focus-visible::border-[#6176AB] focus-visible::ring-[#6176AB] transition-all"
                type="number" name="mobile" v-model.trim="cpParams.contact_number" id="mobile" placeholder="Mobile Number">
            </div>
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="attendees">No of Attendees *</label>
              <!-- <input class="" type="radio" name="attendees" id="attendees" placeholder="Powai"> -->
              <ul class="grid grid-cols-4 radio-input">
                <li v-for="(atend, key) in options" :key="key">
                  <input 
                    type="radio" 
                    :id="'attendee-' + key" 
                    :value="atend" 
                    name="attendees" 
                    class="sr-only peer"
                    required  
                    v-model="cpParams.number_of_attendees"
                  />
                  <label 
                    :for="'attendee-' + key" 
                    class="inline-flex items-center justify-center w-full p-3 text-black inter inter-700 text-opacity-30 bg-white border border-[#CCCCCC] cursor-pointer  peer-checked:bg-[#EEF1F8] peer-checked:border-[#6191AB] peer-checked:text-[#6191AB] hover:text-[#6176AB] hover:bg-gray-100">
                    {{ atend }}
                  </label>
                </li>
              </ul>
            </div>
            <div class="mb-8">
              <label class="block mb-3 text-black inter inter-400 text-[15px]" for="location">Locality *</label>
              <input class="rounded border border-[#CCCCCC] inter inter-400 text-[15px] block w-full p-4 leading-[16px] ring-[#6176AB] focus:border-[#6176AB] focus:ring-[#6176AB] focus-visible::border-[#6176AB] focus-visible::ring-[#6176AB] transition-all"
                type="text" v-model.trim="cpParams.location" required name="location" id="location" placeholder="Locality">
            </div>
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="w-full md:w-auto rounded inter inter-600 text-[15px] text-white leading-[18px] py-4 px-16 mx-auto" style="background: linear-gradient(180deg, #6176AB 0%, #5569A0 100%);">Submit</button>
          <div class="inter inter-400 text-xs text-black text-opacity-50 mt-4">By clicking the submit button, you accept our terms and conditions.</div>
        </div>
      </form>
    </div>
  </div>
</template>
  
  <script>
  export default {
    props: {
      cpParams: {
        type: Object,
        required: true
      },
      submitFn: {
        type: Function,
        required: true
      },
    },
    data() {
      return {
        options: [1,2,3,4]
      }
    },
    }

  </script>

<style>

  .bg-maroon{
    background-image: url('../assets/bg-left.png');
    background-size: cover;
    background-position: center;
  }

  .bg-pattern{
    background-image: url('../assets/bg-pattern.png');
    background-size: cover;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  /* Firefox */
  input[type="number"] {
      -moz-appearance: textfield;
  }

  /* General (Optional) */
  input[type="number"] {
      appearance: textfield; /* Fallback for other browsers */
  }

</style>